import React, { useState } from "react";
import "./advisory-banner.scss";

const VARIANT_CONFIG = {
  warning: { icon: "⚠️", className: "advisory-banner--warning" },
  info: { icon: "ℹ️", className: "advisory-banner--info" },
  critical: { icon: "❗", className: "advisory-banner--critical" },
  success: { icon: "✅", className: "advisory-banner--success" },
  neutral: { icon: "ℹ️", className: "advisory-banner--neutral" },
};

const AdvisoryBanner = ({ banner }) => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const config = VARIANT_CONFIG[banner.variant] || VARIANT_CONFIG.info;

  return (
    <div className={`advisory-banner ${config.className}`}>
      {banner.showIcon && <span className="advisory-banner__icon">{config.icon}</span>}
      <div className="advisory-banner__content">
        {banner.title && <strong className="advisory-banner__title">{banner.title}</strong>}
        <p className="advisory-banner__description">{banner.description}</p>
        {banner.learnMore?.url && (
          <a
            href={banner.learnMore.url}
            target="_blank"
            rel="noopener noreferrer"
            className="advisory-banner__link"
          >
            {banner.learnMore.name || "Learn more"} →
          </a>
        )}
      </div>
      <button className="advisory-banner__close" onClick={() => setVisible(false)}>✕</button>
    </div>
  );
};

export default AdvisoryBanner;
